var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#wallet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.714 8.571V6.285a1.143 1.143 0 0 0-1.142-1.142H1.713A1.143 1.143 0 0 0 .572 6.285v8a1.143 1.143 0 0 0 1.142 1.143h10.858a1.143 1.143 0 0 0 1.142-1.143v-2.857M4.389 2.286l6.48-1.692a.56.56 0 0 1 .697.412l.32 1.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.857 8.571H12a.57.57 0 0 0-.571.572v1.714c0 .316.255.571.571.571h2.857a.57.57 0 0 0 .572-.571V9.143a.57.57 0 0 0-.572-.572"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wallet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgWallet;